<template>
  <div class="device-detail-bd" v-if="Object.keys(funcView).length">
    <div class="header">
      <i class="icon icon-fanhuijiantou" @click="jump($route.query.parentPath)"></i>
      <div class="title">
        {{ deviceInfo.bodyNum }}
      </div>
      <div class="func-group">
        <!--
          componentCode:
            deviceDetail_commonConfig  常用配置
            deviceDetail_service 控制中心
            deviceDetail_otherConfig 其他配置
        -->
        <template v-for="item in ParamGroupTree">
          <el-button
            plain
            v-if="
              (item.componentCode === 'commonConfig' && funcView.deviceDetail_commonConfig) ||
              (item.componentCode === 'service' && funcView.deviceDetail_service) ||
              (item.componentCode === 'otherConfig' && funcView.deviceDetail_otherConfig)
            "
            :key="item.componentCode"
            @click="handleParamList(item.componentCode, item.componentName, item.componentGroup, item.componentDesc)"
          >
            <span class="btn-text" :code="item.componentCode">{{ item.componentName }}</span>
          </el-button>
        </template>
      </div>
    </div>
    <div class="page-content clear">
      <div class="device-param">
        <div class="header">
          <div class="device-sn">{{ deviceInfo.productName }}</div>
          <div class="device-state">
            <div class="device-state-tag" v-for="(item, index) in statusList" :key="index" :class="{ 'has-name': item.name }">
              <i :class="item.className"></i>
              <span class="state-name">{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div class="device-img" :class="{ gray: !curProductImg, offline: !deviceInfo.isOnline }">
          <img :src="curProductImg" alt v-if="curProductImg" />
        </div>
        <div class="device-status-container" v-if="deviceInfo.isOnline">
          <ul class="device-status">
            <li class="battery" v-if="deviceInfo.batteryCharge || deviceInfo.batteryCharge === 0">
              <div class="key">
                <icon type="battery" :value="deviceInfo.batteryCharge"></icon>
              </div>
              <div class="val">{{ deviceInfo.batteryCharge || deviceInfo.batteryCharge === 0 ? deviceInfo.batteryCharge : '-' }}%</div>
            </li>
            <li class="signal" v-if="(`${deviceInfo.networkType}` === '1' && `${deviceInfo.cellularMode}` === '1') || (`${deviceInfo.networkType}` === '0' && `${deviceInfo.cellularMode}` !== '1')">
              <div class="key">
                <!--
                  deviceInfo.cellularMode
                    1-WIFI
                    2-2G
                    3-3G
                    4-4G
                 -->
                <i v-if="`${deviceInfo.networkType}` === '1' && `${deviceInfo.cellularMode}` === '1'" class="icon-wifi-i" :class="wifi(deviceInfo.signal)"></i>
                <i v-else-if="`${deviceInfo.networkType}` === '0' && `${deviceInfo.cellularMode}` !== '1'" class="icon-signal-i" :class="signal(deviceInfo.signal)"></i>
              </div>
              <!--
                networkType 和 cellularMode都为1显示
                networkType 0和cellularMode不为1显示
                其余不显示
              -->
              <div class="val" v-if="(`${deviceInfo.networkType}` === '1' && `${deviceInfo.cellularMode}` === '1') || (`${deviceInfo.networkType}` === '0' && `${deviceInfo.cellularMode}` !== '1')">
                {{ getDicValue('dms_device_cellular_mode', deviceInfo.cellularMode) || '-' }}
              </div>
              <!-- <div class="val">{{ deviceInfo.networkType ? getDicValue('dms_device_network_type', deviceInfo.networkType): '-' }}</div> -->
            </li>
            <li class="temperature" v-if="deviceInfo.batteryTemp || deviceInfo.batteryTemp === 0">
              <div class="key">
                <!-- <i type="temperature" :value="deviceInfo.batteryTemp"></i> -->
                <icon type="temperature" :value="deviceInfo.batteryTemp"></icon>
              </div>
              <div class="val">{{ $celsiusToFahrenheit(deviceInfo.batteryTemp) ||'-' }}{{$formatTempUnit()}}</div>
            </li>
          </ul>
        </div>
        <ul class="param-detail">
          <li>
            <div class="content">
              <div class="key">
                {{ $t('dms_device_detail.pin_pai') }}
              </div>
              <div class="val">{{ getDicValue('iot_product_brand', deviceInfo.productBrand) || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ 'Modem SN' }}
              </div>
              <div class="val">{{ deviceInfo.modemSn || '-' }}</div>
            </div>
          </li>
          <li v-if="deviceInfo.imsi">
            <div class="content">
              <div class="key">
                IMSI
              </div>
              <div class="val">{{ deviceInfo.imsi || '-' }}</div>
            </div>
          </li>
          <li v-if="deviceInfo.machineVersion">
            <div class="content">
              <div class="key">
                {{$t('dms_device_detail.ji_qi_ban_ben')}}
              </div>
              <div class="val">{{ deviceInfo.machineVersion || '-' }}</div>
            </div>
          </li>
          <li v-if="deviceInfo.simState">
            <div class="content">
              <div class="key">
                {{ $t('dms_device_detail.SIMzhuang_tai') }}
              </div>
              <div class="val">{{ getDicValue('sim_status', deviceInfo.simState) || '-' }}</div>
            </div>
          </li>
          <li v-if="deviceInfo.deviceName">
            <div class="content">
              <div class="key">
                {{ $t('dms_device_detail.she_bei_ming_cheng') }}
              </div>
              <div class="val">{{ deviceInfo.deviceName || '-' }}</div>
            </div>
          </li>
          <li v-if="deviceInfo.iccid">
            <div class="content">
              <div class="key">
                {{ 'ICCID' }}
              </div>
              <div class="val">{{ deviceInfo.iccid || '-' }}</div>
            </div>
          </li>
          <!-- <li>
            <div class="content">
              <div class="key">
                {{ $t('label_deviceBizType }}
              </div>
              <div class="val">{{ getDicValue('dms_device_biz_type', deviceInfo.deviceBizType) || '-' }}</div>
            </div>
          </li> -->
          <!-- <li>
            <div class="content">
              <div class="key">
                {{ $t('label_deviceName') }}
              </div>
              <div class="val">{{ deviceInfo.deviceName || '-' }}</div>
            </div>
          </li> -->
          <li
            v-if="deviceInfo.isOnline && ((`${deviceInfo.networkType}` === '1' && `${deviceInfo.cellularMode}` === '1') || (`${deviceInfo.networkType}` === '0' && `${deviceInfo.cellularMode}` !== '1'))"
          >
            <div class="content">
              <div class="key">
                {{ $t('dms_device_detail.wang_luo_xin_hao') }}
              </div>
              <!-- <div class="val">{{ deviceInfo.networkType}}  {{ getDicValue('dms_device_network_type', deviceInfo.networkType) || '-' }}</div> -->
              <div class="val">{{ getDicValue('dms_device_cellular_mode', deviceInfo.cellularMode) || '-' }} {{ deviceInfo.signal > -1 ? `${deviceInfo.signal}%` : '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('dms_device_detail.zhlxsj') }}
              </div>
              <div class="val">{{ momentAmPm($momentLocal(deviceInfo.lastOnlineTime) || '-') }}</div>
            </div>
          </li>
          <li v-if="!deviceInfo.isOnline && deviceInfo.offlineDays>0">
            <div class="content">
              <div class="key">
                {{ $t('dms_device_detail.li_xian_tian_shu') }}
              </div>
              <div class="val">{{ deviceInfo.offlineDays || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('dms_device_detail.zhqjsj') }}
              </div>
              <div class="val">{{ momentAmPm($momentLocal(deviceInfo.lastCleanStartTime) || '-') }}</div>
            </div>
          </li>
          <li v-if="deviceInfo.lockState">
            <div class="content">
              <div class="key">
                {{ $t('dms_device_detail.suo_ji_shi_jian') }}
              </div>
              <div class="val">{{ momentAmPm($momentLocal(deviceInfo.lockTime) || '-') }}</div>
            </div>
          </li>
          <li v-if="deviceInfo.lockState">
            <div class="content">
              <div class="key">
                {{ $t('dms_device_detail.suo_ji_yuan_yin') }}
              </div>
              <div class="val" v-if="deviceInfo.billLockState">
                <template v-if="`${deviceInfo.billLockType}`==='1'">{{ $t('dms_device_detail.she_bei_dao_qi') }}</template>
                <template v-else-if="`${deviceInfo.billLockType}`==='2'">{{ $t('dms_device_detail.zbwsdzk') }}</template>
                <template v-else-if="`${deviceInfo.billLockType}`==='3'">{{ $t('dms_device_detail.dlgswsdzk') }}</template>
              </div>
              <div class="val" v-else-if="deviceInfo.stockLockState">
                {{ $t('dms_device_detail.shi_yong_chao_shi') }}
              </div>
              <div class="val" v-else-if="deviceInfo.freeLockState">
                {{deviceInfo.freeLockUser}}{{ $t('dms_device_detail.cao_zuo_suo_ji') }}
              </div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('dms_device_detail.ji_huo_zhuang_tai') }}
              </div>
              <div class="val">
                <el-popover v-if="deviceInfo.activateState && (deviceInfo.activationId || deviceInfo.lastActivationTime)" placement="top-start" trigger="hover">
                  <ul>
                    <li class="cell-pop-item" v-if="deviceInfo.activationId">{{ $t('dms_device_detail.ji_huoID') }}：{{ deviceInfo.activationId || '-' }}</li>
                    <li class="cell-pop-item" v-if="deviceInfo.lastActivationTime">{{ $t('dms_device_detail.ji_huo_shi_jian') }}：{{ momentAmPm($momentLocal(deviceInfo.lastActivationTime) || '-') }}</li>
                  </ul>
                  <div class="cell-pop" slot="reference">{{ getDicValue('dms_device_activate_state', deviceInfo.activateState) }}</div>
                </el-popover>
                <div v-else>{{ getDicValue('dms_device_activate_state', deviceInfo.activateState) }}</div>
              </div>
            </div>
          </li>
          <li v-if="deviceInfo.siteName">
            <div class="content">
              <div class="key">
                {{ $t('dms_device_detail.qu_yu') }}
              </div>
              <div class="val">
                <el-popover v-if="deviceInfo.siteName && deviceInfo.siteCode" placement="top-start" trigger="hover">
                  <ul>
                    <li class="cell-pop-item" v-if="deviceInfo.siteCode">{{ $t('dms_device_detail.zhan_dianID') }}：{{ deviceInfo.siteCode || '-' }}</li>
                  </ul>
                  <div class="cell-pop" slot="reference">{{ deviceInfo.siteName }}</div>
                </el-popover>
                <div v-else>{{ deviceInfo.siteName || '-' }}</div>
              </div>
            </div>
          </li>
          <li v-if="deviceInfo.timezone">
            <div class="content">
              <div class="key">
                {{ $t('dms_device_detail.shi_qu') }}
              </div>
              <div class="val">
                <el-popover v-if="deviceInfo.timezone" placement="top-start" trigger="hover">
                  <ul>
                    <li class="cell-pop-item">{{ $t('dms_device_detail.Pagerpin_dao') }}：{{ deviceInfo.pagerChannel || '-' }}</li>
                    <li class="cell-pop-item">{{ $t('dms_device_detail.di_zhi') }}：{{ deviceInfo.siteAddress || '-' }}</li>
                    <li class="cell-pop-item">{{ $t('dms_device_detail.mo_ren_yu_yan') }}：{{ deviceInfo.defaultLocale || '-' }}</li>
                  </ul>
                  <div class="cell-pop" slot="reference">{{ deviceInfo.timezone }}</div>
                </el-popover>
                <div v-else>{{ deviceInfo.timezone || '-' }}</div>
              </div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('dms_device_detail.di_zhi') }}
              </div>
              <div class="val" @click="onGps">
                <el-popover v-if="deviceInfo.gpsAddress && (deviceInfo.locationType || deviceInfo.lastLocationTime)" placement="top-start" trigger="hover">
                  <ul>
                    <li class="cell-pop-item" v-if="deviceInfo.locationType">{{ $t('dms_device_detail.ding_wei_fang_shi') }}：{{ getDicValue('iot_location_type', deviceInfo.locationType) || '-' }}</li>
                    <li class="cell-pop-item" v-if="deviceInfo.lastLocationTime">{{ $t('dms_device_detail.zhdwsj') }}：{{ momentAmPm($momentLocal(deviceInfo.lastLocationTime) || '-') }}</li>
                  </ul>
                  <div class="cell-pop" slot="reference">{{ deviceInfo.gpsAddress }}</div>
                </el-popover>
                <div v-else>{{ deviceInfo.gpsAddress || '-' }}</div>
              </div>
            </div>
          </li>
          <!-- <li>
            <div class="content">
              <div class="key">
                {{ $t('label_bizState }}
              </div>
              <div class="val">
                <div>{{ getDicValue('order_device_biz_state', deviceInfo.bizState) || '-' }}</div>
              </div>
            </div>
          </li> -->
          <li v-if="bizType === 'HQ' || bizType === 'PF'">
            <div class="content">
              <div class="key">
                {{ $t('dms_device_detail.xie_yi_lei_bie') }}
              </div>
              <div class="val">
                <div>{{ getDicValue('iot_protocol_class', deviceInfo.protocolClass) || '-' }}</div>
              </div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('dms_device_detail.chu_chang_ri_qi') }}
              </div>
              <div class="val">
                <div>{{ productionDate }}</div>
              </div>
            </div>
          </li>
        </ul>
        <ul class="other-param-detail">
          <!-- 人工 -->
          <li v-if="deviceInfo.manualUsageTime">
            <div class="key">
              {{ $t('dms_device_detail.ljrgyxschm') }}
            </div>
            <div class="val">{{ momentAmPm($momentLocal(deviceInfo.manualUsageTime)) }}</div>
          </li>
          <li v-if="deviceInfo.manualUsageCount">
            <div class="key">
              {{ $t('dms_device_detail.ljrgyxcs') }}
            </div>
            <div class="val">{{ deviceInfo.manualUsageCount }}</div>
          </li>
          <li v-if="deviceInfo.manualCleanArea">
            <div class="key">
              {{ $t('dms_device_detail.ljrgqjmj') }}{{`(${$formatLenUnit()})`}}
            </div>
            <div class="val">{{$formatLenLocal($toFixed(deviceInfo.manualCleanArea) ) }}</div>
          </li>
          <!-- 教学 -->
          <li v-if="deviceInfo.trainingUsageTime">
            <div class="key">
              {{ $t('dms_device_detail.ljjxyxschm') }}
            </div>
            <div class="val">{{ momentAmPm($momentLocal(deviceInfo.trainingUsageTime)) }}</div>
          </li>
          <li v-if="deviceInfo.trainingUsageCount">
            <div class="key">
              {{ $t('dms_device_detail.ljjxyxcs') }}
            </div>
            <div class="val">{{ deviceInfo.trainingUsageCount }}</div>
          </li>
          <li v-if="deviceInfo.trainingCleanArea">
            <div class="key">
              {{ $t('dms_device_detail.ljjxqjmj') }}{{`(${$formatLenUnit()})`}}
            </div>
            <div class="val">{{ $formatLenLocal($toFixed(deviceInfo.trainingCleanArea)) }}</div>
          </li>
          <!-- 自动 -->
          <li v-if="deviceInfo.autonomousUsageTime">
            <div class="key">
              {{ $t('dms_device_detail.ljzzyxschm') }}
            </div>
            <div class="val">{{ momentAmPm($momentLocal(deviceInfo.autonomousUsageTime)) }}</div>
          </li>
          <li v-if="deviceInfo.autonomousUsageCount">
            <div class="key">
              {{ $t('dms_device_detail.ljzzyxcs') }}
            </div>
            <div class="val">{{ deviceInfo.autonomousUsageCount }}</div>
          </li>
          <li v-if="deviceInfo.autonomousCleanArea">
            <div class="key">
              {{ $t('dms_device_detail.ljzzqjmj') }}{{`(${$formatLenUnit()})`}}
            </div>
            <div class="val">{{$formatLenLocal($toFixed(deviceInfo.autonomousCleanArea))  }}</div>
          </li>
        </ul>
      </div>
      <div class="tap-content" :class="{ mapbox: tabIndex === 'location' }">
        <custom-tab :list="tabData" v-model="tabIndex"></custom-tab>
        <!-- 设备状态 -->
        <status ref="status" v-if="tabIndex === 'status'" :deviceInfo="deviceInfo"></status>
        <!-- 使用报表 -->
        <sheet v-if="tabIndex === 'sheet'" :deviceInfo="deviceInfo"></sheet>
        <!-- 事件记录 -->
        <log v-if="tabIndex === 'log'" :deviceInfo="deviceInfo"></log>
        <!-- 事件记录 -->
        <event v-if="tabIndex === 'event'" :deviceInfo="deviceInfo"></event>
        <!-- 业务信息 -->
        <biz-info v-if="tabIndex === 'business'" :deviceInfo="deviceInfo"></biz-info>
        <!-- 位置信息 -->
        <location v-if="tabIndex === 'location' && `${siteCode}`.includes('cn')" :deviceInfo="deviceInfo" :propsFuncView="funcView"></location>
        <google-location v-if="tabIndex === 'location' && !`${siteCode}`.includes('cn')" :deviceInfo="deviceInfo"  :propsFuncView="funcView"></google-location>
        <!-- 开机卡信息 -->
        <password-card v-if="tabIndex === 'passwordCard'" :deviceInfo="deviceInfo"></password-card>
        <!-- 开机卡信息 -->
        <open-card v-if="tabIndex === 'openCard'" :deviceInfo="deviceInfo"></open-card>
        <!-- 出入库记录 -->
        <stock-record v-if="tabIndex === 'stockRecord'" :deviceInfo="deviceInfo"></stock-record>
        <!-- 待处理故障 -->
        <fault v-if="tabIndex === 'fault'" :deviceInfo="deviceInfo"></fault>
        <!-- 售后记录 -->
        <record v-if="tabIndex === 'record'" :deviceInfo="deviceInfo"></record>
        <!-- 测试报告 -->
        <report v-if="tabIndex === 'report'" :deviceInfo="deviceInfo"></report>
        <!-- 路线管理 -->
        <route v-if="tabIndex === 'route'" :deviceInfo="deviceInfo"></route>
        <!-- 机器履历 -->
        <resume v-if="tabIndex === 'resume'" :deviceInfo="deviceInfo"></resume>
      </div>
    </div>

    <!-- 参数配置 -->
    <device-param-drawer v-if="dialogVisible" :data="dialogData" :model="dialogModel" :funView="funcView" @close="dialogVisible = false"></device-param-drawer>
    <!-- 设备控制中心 -->
    <device-control-drawer v-if="dialogVisible2" :data="dialogData2" :model="dialogModel2" @close="dialogVisible2 = false"></device-control-drawer>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import apis from '@/utils/apis';
import icon from '@/components/icon.vue';
import report from '@/pages/dms/components/device_detail_report.vue';
import deviceParamDrawer from '@/pages/dms/components/deviceParamDrawer';
import deviceControlDrawer from '@/pages/dms/components/deviceControlDrawer';
import event from '@/pages/dms/components/device_detail_event.vue';
import status from './children/device_detail_status.vue';
import bizInfo from './children/device_detail_biz_info.vue';
import log from './children/device_detail_log.vue';
import fault from './children/device_detail_fault.vue';
import record from './children/device_detail_record.vue';
import sheet from './children/device_detail_sheet.vue';
import location from './children/device_detail_location.vue';
import googleLocation from './children/device_detail_location_google.vue';
import openCard from './children/device_detail_openCard.vue';
import passwordCard from './children/device_detail_passwordCard.vue';
import stockRecord from './children/device_detail_stockRecord.vue';
import route from './children/device_detail_route.vue';
import resume from './children/device_detail_resume.vue';
// 参数设置弹窗

export default {
  name: 'devicedetail',
  components: {
    status,
    bizInfo,
    log,
    event,
    fault,
    record,
    sheet,
    report,
    route,
    location,
    icon,
    deviceParamDrawer,
    deviceControlDrawer,
    openCard,
    stockRecord,
    googleLocation,
    passwordCard,
    resume
  },
  computed: {
    curProductImg() {
      if (this.imgList.length) {
        return this.imgList[0].url;
      }
      return '';
    },
    // 设备状态icon列表
    statusList() {
      if (Object.keys(this.deviceInfo).length) {
        const ret = [];
        // 设备唯一状态
        const machineStatusList = [
          // 空闲
          {
            type: 'free',
            value: '1',
            className: 'icon icon-free blue',
            name: this.getDicValue('machine_state', '1'),
          },
          // 手工清洁
          {
            type: 'handCleaning',
            value: '2',
            className: 'icon icon-cleaning blue',
            name: this.getDicValue('machine_state', '2'),
          },
          // 教学
          {
            type: 'teach',
            value: '3',
            className: 'icon icon-cleaning blue',
            name: this.getDicValue('machine_state', '3'),
          },
          // 智能清洁
          {
            type: 'intelligentCleaning',
            value: '4',
            className: 'icon icon-cleaning blue',
            name: this.getDicValue('machine_state', '4'),
          },
          // 协助
          {
            type: 'assist',
            value: '5',
            className: 'icon icon-assist red',
            name: this.getDicValue('machine_state', '5'),
          },
          // 暂停
          {
            type: 'stop',
            value: '6',
            className: 'icon icon-suspend blue',
            name: this.getDicValue('machine_state', '6'),
          },
        ];
        const { isCharging, lockState, isMalfunction, isOnline, isPowerSave, isRunning, machineState } = this.deviceInfo;

        // 如果是离线状态，不显示其他实时状态(只有锁机 故障 省电)
        if (!isOnline) {
          // 显示锁机(自由锁1 账单锁2)
          if (lockState) {
            ret.push({
              type: 'lock',
              value: lockState,
              className: 'icon icon-locking gray',
              dicCode: 'isLock',
            });
          }
          // 故障
          if (isMalfunction) {
            ret.push({
              type: 'malfunction',
              value: isMalfunction,
              className: 'icon icon-warning red',
              dicCode: 'isFault',
            });
          }
          // 是否省电模式
          if (isPowerSave) {
            ret.push({
              type: 'power',
              value: isPowerSave,
              className: 'icon icon-leaf green',
              dicCode: 'isPowerSave',
            });
          }

          ret.push({
            type: 'online',
            value: isOnline,
            className: 'icon icon-machine-offline gray',
            dicCode: 'isOffline',
            name: this.getDicValue('cloud_common_online', isOnline),
          });
        } else {
          // 设备多状态：可以同时存在多个的状态
          /** 设备多状态 start */

          if (lockState) {
            ret.push({
              type: 'lock',
              value: lockState,
              className: 'icon icon-locking gray',
              dicCode: 'isLock',
            });
          }
          if (isMalfunction) {
            ret.push({
              type: 'malfunction',
              value: isMalfunction,
              className: 'icon icon-warning red',
              dicCode: 'isFault',
            });
          }

          if (isPowerSave) {
            ret.push({
              type: 'power',
              value: isPowerSave,
              className: 'icon icon-leaf green',
              dicCode: 'isPowerSave',
            });
          }
          if (isRunning) {
            ret.push({
              type: 'running',
              value: isRunning,
              className: 'icon icon-using green',
              dicCode: 'isRunning',
            });
          }
          if (isCharging) {
            ret.push({
              type: 'charge',
              value: isCharging,
              className: 'icon icon-charge yellow',
              dicCode: 'isCharging',
              name: this.$t('dms_device_detail.chong_dian_zhong'),
            });
          }
          // else {
          //   ret.push({
          //     type: 'running',
          //     value: isRunning,
          //     className: 'icon icon-suspend blue',
          //     dicCode: 'isOnline'
          //   });
          // }

          // if (this.ret.some(item => item.type === 'lock')) {

          // }

          // 设备唯一状态：同时只能出现一种的

          // 如果出现了充电中 机器状态就替换成充电中
          // if (isCharging && machineState !== '1') {
          //   if (obj) {
          //     ret.push(obj);
          //   }
          // } else
          if (!isCharging && machineState !== '1') {
            const obj = machineStatusList.find(item => item.value === `${machineState}`);
            if (obj) {
              ret.push(obj);
            }
          }
          /** 设备多状态 end */
        }
        return ret;
      }
      return [];
    },
    tabData() {
      const arr = [];
      // 设备状态
      if (this.funcView.deviceDetail_device_status) {
        arr.push({
          name: this.$t('dms_device_detail.she_bei_zhuang_tai'),
          value: 'status',
        });
      }
      // 使用报表
      if (this.funcView.deviceDetail_using_excel) {
        arr.push({
          name: this.$t('dms_device_detail.shi_yong_bao_biao'),
          value: 'sheet',
        });
      }
      // 路线管理
      // 传统机器没有路线管理（传统机器productClass为1）
      if (this.funcView.deviceDetail_route_mange && `${this.deviceInfo.productClass}` !== '1') {
        arr.push({
          name: this.$t('dms_device_detail.lu_xian_guan_li'),
          value: 'route'
        });
      }
      // 事件记录
      if (this.funcView.deviceDetail_event_record) {
        arr.push({
          name: this.$t('dms_device_detail.shi_jian_ji_lu'),
          value: 'event',
        });
      }
      // 位置信息
      if (this.funcView.deviceDetail_physical_msg) {
        arr.push({
          name: this.$t('dms_device_detail.wei_zhi_xin_xi'),
          value: 'location',
        });
      }
      // 开机卡信息
      if (this.funcView.deviceDetail_open_card && `${this.deviceInfo.cardClass}` === '1') {
        arr.push({
          name: this.$t('dms_device_detail.kai_ji_ka_xin_xi'),
          value: 'openCard',
        });
      }
      // 开机密码信息
      if (this.funcView.deviceDetail_open_card && `${this.deviceInfo.cardClass}` === '2') {
        arr.push({
          name: this.$t('dms_device_detail.kai_ji_mi_ma_xin_xi'),
          value: 'passwordCard',
        });
      }
      // 业务信息
      if (this.funcView.deviceDetail_business_information) {
        arr.push({
          name: this.$t('dms_device_detail.ye_wu_xin_xi'),
          value: 'business',
        });
      }

      // 待处理故障
      if (this.funcView.deviceDetail_unresolved_fault) {
        arr.push({
          name: this.$t('dms_device_detail.dai_chu_li_gu_zhang'),
          value: 'fault',
        });
      }
      // 售后记录
      if (this.funcView.deviceDetail_sales_record) {
        arr.push({
          name: this.$t('dms_device_detail.shou_hou_ji_lu'),
          value: 'record',
        });
      }
      // 设备日志
      if (this.funcView.deviceDetail_device_log) {
        arr.push({
          name: this.$t('dms_device_detail.she_bei_ri_zhi'),
          value: 'log',
        });
      }
      // 出入库记录
      if (this.funcView.deviceDetail_stock_record) {
        arr.push({
          name: this.$t('dms_device_detail.chu_ru_ku_ji_lu'),
          value: 'stockRecord',
        });
      }
      // 测试报告
      if (this.funcView.deviceDetail_testing_report) {
        arr.push({
          name: this.$t('dms_device_detail.ce_shi_bao_gao'),
          value: 'report',
        });
      }
      // 测试报告
      if (this.funcView.deviceDetail_resume) {
        arr.push({
          name: this.$t('dms_device_detail.she_bei_lv_li'),
          value: 'resume',
        });
      }

      return arr;
    },
    productionDate() {
      if (this.deviceInfo.productionTime) {
        return this.$momentLocal(this.deviceInfo.productionTime, 'YYYY-MM-DD');
        // return moment(this.deviceInfo.productionTime).format('YYYY-MM-DD');
      }
      return '-';
    },
    bizType() {
      return this.$store.state.userInfo.bizType;
    },
  },
  watch: {
    '$route.query': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.deviceId = this.getJump('deviceId');
        this.bodyNum = this.getJump('bodyNum');
        this.getDeviceInfo();
      }
    },
    tabData: {
      immediate: false,
      handler(val) {
        if (val && val.length && this.tabIndex === '') {
          this.tabIndex = this.tabData[0].value;
        }
      },
    },

  },
  data() {
    return {
      provide: true,
      tabIndex: '',
      deviceId: '',
      deviceInfo: {},
      workInfo: {},
      imgList: [],
      ParamGroupTree: [],

      bodyNum: '',
      // 参数设置
      dialogVisible: false,
      dialogData: {},
      dialogModel: {},

      dialogVisible2: false,
      dialogData2: {},
      dialogModel2: {},
      refreshData: {},
      siteCode: '',
    };
  },

  mounted: function () {
    this.deviceId = this.getJump('deviceId');
    this.bodyNum = this.getJump('bodyNum');
    // this.getDeviceInfo();
    // 在首次加载时手动调用，确保参数已就绪
    if (this.deviceId || this.bodyNum) {
      this.getDeviceInfo();
    }
    this.getFuncView('/deviceDetail');
    this.siteCode = Cookies.get('siteCode') || 'cn';
  },
  methods: {
    // 获取设备详情
    getDeviceInfo: function () {

      const reqUrl = this.deviceId ? `${apis.DeviceInfo}/${this.deviceId}` : apis.DeviceInfo;
      this.$getJSON(reqUrl, {
        bodyNum: this.bodyNum,
      }).then((res) => {
        this.deviceInfo = res.data;
        // this.tabIndex = 'status';
        this.getImgList(this.deviceInfo.productCodeId, 'dms.product.icon');
        this.bodyNum = res.data.bodyNum;

        this.getParamGroupTree();
      });
    },
    // 获取图片列表
    getImgList(bizId, bizType) {
      this.$getFileList({ bizId, bizType }).then((list) => {
        this.imgList = list;
        this.deviceInfo.productImage = list;
      });
    },
    // 参数查询
    // TslDeviceParamList
    // 查询参数分组树 2020050900
    getParamGroupTree: function () {
      this.$getJSON(apis.DeviceResumeParamGroupList, {
        bodyNum: this.bodyNum,
      }).then((res) => {
        this.ParamGroupTree = res.data;
      });
    },
    // 点击位置
    onGps: function () {
      this.tabIndex = 'location';
    },
    // 通过groupCode 查询参数
    handleParamList(componentCode, componentName, componentGroup, componentDesc) {
      // 暂时用不上 取消了刷新  刷新在部件刷新里面
      // if (componentGroup === 3) {
      //   this.$postJSON(apis.DeviceResumeRefresh, {
      //     bodyNum: this.bodyNum,
      //     componentCode,
      //   }).then(() => {
      //     this.$message({
      //       type: 'success',
      //     });
      //     this.getDeviceInfo();
      //     if (this.tabIndex === 'status') {
      //       this.$refs.status.udpate();
      //     }
      //   });
      //   return;
      // }
      // 控制中心
      if (componentGroup === 2) {
        this.dialogVisible2 = true;
        this.dialogModel2.title = componentName;
        this.dialogModel2.desc = componentDesc;
        this.dialogModel2.type = 'edit';
        this.dialogData2.bodyNum = this.bodyNum;
        // this.dialogData2.structureId = structureId;
        this.dialogData2.componentCode = componentCode;
        this.dialogData2.componentGroup = componentGroup;
      } else {
        this.dialogVisible = true;
        this.dialogModel.title = componentName;
        this.dialogModel.desc = componentDesc;
        this.dialogModel.type = 'edit';
        this.dialogData.bodyNum = this.bodyNum;
        this.dialogData.componentCode = componentCode;
        this.dialogData.componentGroup = componentGroup;
      }
    },

    signal(val) {
      if (val > 80) {
        return 'signal-xinhao100';
      }
      if (val > 50 && val <= 80) {
        return 'signal-xinhao75';
      }
      if (val > 25 && val <= 50) {
        return 'signal-xinhao50';
      }
      return 'signal-xinhao25';
    },
    wifi(val) {
      if (val > 80) {
        return 'wifi100';
      }
      if (val > 0 && val <= 80) {
        return 'wifi66';
      }
      return 'wifi33';
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.device-detail-bd {
  padding: 0 16px 16px;

  .icon-fanhuijiantou {
    color: #394668;
    &:hover {
      cursor: pointer;
    }
  }

  > .header {
    padding: 24px 0 16px 0;
    height: 68px;
    overflow: hidden;
    .icon {
      font-size: 16px;
      float: left;
      line-height: 30px;
      font-weight: bold;
    }
    .title {
      float: left;
      margin-left: 18px;
      color: #394668;
      font-size: 18px;
      line-height: 32px;
      &:hover {
        cursor: pointer;
      }
    }
    .func-group {
      float: right;

      .btn-text {
        line-height: 24px;
        // padding-right: 14px;
      }

      .icon-xiala {
        color: #0d9ae0;
      }

      .el-dropdown {
        float: left;
      }

      .el-button {
        float: left;
        margin-left: 8px;
      }
    }
  }
  .page-content {
    width: 100%;
    height: calc(100% - 68px);
    min-width: 1300px;
    .device-param {
      width: 300px;
      background: #fff;
      padding: 0 24px;
      float: left;
      margin-right: 16px;

      .header {
        height: 40px;
        position: relative;
        .device-sn {
          float: left;
          color: #495057;
          font-size: 14px;
          font-weight: bold;
          line-height: 24px;
          margin-top: 16px;
          margin-left: -8px;
        }
        .device-state {
          position: absolute;
          top: 16px;
          right: -8px;
          .device-state-tag {
            $r: 24px;
            width: $r;
            height: $r;
            border-radius: $r / 2;
            background: rgba(13, 154, 224, 0.05);
            overflow: hidden;
            float: left;
            &.has-name {
              width: auto;
              padding-right: 10px;
              line-height: $r;
              .icon {
                margin-left: 9px;

                &.icon-cleaning,
                &.icon-free {
                  font-size: 18px;
                }

                &.icon-cleaning {
                  margin-top: 5px;
                }
                &.icon-suspend,
                &.icon-free,
                &.icon-charge {
                  margin-top: 4px;
                }

                &.icon-machine-offline {
                  margin-top: 5px;
                  font-size: 18px;
                }
              }
            }
            &:nth-child(n + 2) {
              margin-left: 6px;
            }

            .icon {
              $r: 18px;
              width: $r;
              height: $r;
              text-align: center;
              line-height: $r;
              float: left;
              margin-top: 3px;
              margin-left: 3px;
              font-size: 14px;

              // &.icon-machine-offline,

              &.blue {
                color: #0d9ae0;
              }

              &.red {
                color: #ff5c5b;
              }
              &.yellow {
                color: #f99751;
              }
              &.gray {
                color: #6d757d;
              }
              &.green {
                color: #16d071;
              }
            }

            .state-name {
              float: left;
              font-size: 12px;
              color: #495057;
              margin-left: 3px;
            }
          }
        }
      }

      .device-img {
        &.gray {
          background: #f5f5f5;
        }
        $r: 160px;
        width: $r;
        height: $r;
        margin: 24px auto 0 auto;
        position: relative;

        &.offline {
          /** 图片去色 */
          -webkit-filter: grayscale(100%);
          -moz-filter: grayscale(100%);
          -ms-filter: grayscale(100%);
          -o-filter: grayscale(100%);
          filter: grayscale(100%);
          filter: gray;
        }

        > img {
          position: absolute;
          max-width: 100%;
          max-height: 100%;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          margin: auto;
        }
      }

      .device-status-container {
        text-align: center;
        font-size: 0;
        .device-status {
          font-size: 12px;
          color: #4d4d4d;
          margin-top: 24px;
          overflow: hidden;
          display: inline-block;

          > li {
            float: left;
            height: 24px;
            &:nth-child(n + 2) {
              margin-left: 16px;
            }
            &.signal {
              .val {
                padding-left: 2px;
              }
            }
            .key {
              float: left;
              color: #00a0d9;
              .icon {
                float: left;
                font-size: 14px;
                line-height: 24px;
              }
            }
            .val {
              float: left;
              margin-left: 2px;
              line-height: 23px;
            }

            .icon-wifi-i,
            .icon-signal-i {
              float: left;
              // display: inline-block;
              height: 14px;
              width: 14px;
              margin-top: 3.5px;
              line-height: 23px;
              background-repeat: no-repeat;
              background-position: center;
              background-size: 100%;
            }
            .signal-xinhao100 {
              background-image: url('~@/images/layout/icon-signal-100.svg');
            }
            .signal-xinhao75 {
              background-image: url('~@/images/layout/icon-signal-75.svg');
            }
            .signal-xinhao50 {
              background-image: url('~@/images/layout/icon-signal-50.svg');
            }
            .signal-xinhao25 {
              background-image: url('~@/images/layout/icon-signal-25.svg');
            }
            .wifi100 {
              background-image: url('~@/images/layout/icon-wifi-100.svg');
            }
            .wifi66 {
              background-image: url('~@/images/layout/icon-wifi-66.svg');
            }
            .wifi33 {
              background-image: url('~@/images/layout/icon-wifi-33.svg');
            }
          }
        }
      }

      .param-detail {
        margin-top: 24px;
        color: #6c757d;
        font-size: 12px;
        > li {
          padding: 8px 0 7px 0;
          border-bottom: 1px solid #eef2f7;
          .content {
            overflow: hidden;
            line-height: 18px;
            .key {
              width: 40%;
              float: left;
            }
            .val {
              float: right;
              width: 60%;
              text-align: right;
              word-break: break-all;
              .active-status {
                float: right;
                padding-left: 11px;
                position: relative;
                &.actived,
                &.no-active {
                  &::before {
                    $r: 5px;
                    content: ' ';
                    width: $r;
                    height: $r;
                    border-radius: 100%;
                    position: absolute;
                    left: 0;
                    top: 0;
                    bottom: 0;
                    margin: auto;
                  }
                }
                &.actived {
                  &::before {
                    background: #0d9ae0;
                  }
                }
                &.no-active {
                  &::before {
                    background: #b3b3b3;
                  }
                }
              }
            }
          }
          .adress {
            margin-top: 6px;
            color: #98a6ad;
            line-height: 17px;
          }
        }
      }

      .other-param-detail {
        margin-top: 21px;
        margin-bottom: 20px;
        font-size: 12px;
        color: #6c757d;
        > li {
          line-height: 32px;
          overflow: hidden;
          // &:nth-child(n + 2) {
          //   margin-top: 1px;
          // }
        }
        .key,
        .val {
          float: left;
          width: 70%;
        }
        .val {
          width: 30%;
          text-align: right;
        }
      }
    }

    .tap-content {
      overflow: hidden;
      background: #fff;
      &.mapbox {
        height: calc(100% - 84px);
        min-height: 789px;
        position: absolute;
        top: 68px;
        left: 332px;
        right: 16px;
      }
    }
  }
}
</style>
